import script from "./BVIoffice.vue?vue&type=script&setup=true&lang=js"
export * from "./BVIoffice.vue?vue&type=script&setup=true&lang=js"

import "./BVIoffice.vue?vue&type=style&index=0&id=329eadbc&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329eadbc"]])

export default __exports__